import React from "react";

import "./SettingErrors.css";
import AttentionBox from "./common/AttentionBox";

interface Props {
    errors: string[];
}

const SettingErrors: React.FC<Props> = function ({ errors }: Props) {
    return (
        <div className="setting_errors">
            <AttentionBox title="Please check View Settings">
                {errors.map((error) => (
                    <p key={error}>{error}</p>
                ))}
            </AttentionBox>
        </div>
    );
};

export default SettingErrors;
